import { Component, effect, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CatalogAssembly } from 'src/app/models/catalog-assembly';
import { UserAccessService } from 'src/app/services/app/user-access.service';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { CurrencyPipe } from '@angular/common';
import { RichTextEditorComponent } from '@/global/rich-text-editor.component';
import { CategoriesService } from '@/services/api/categories.service';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'app-custom-assembly',
    imports: [
      ReactiveFormsModule,
      RichTextEditorComponent,
      InputTextModule,
      ButtonModule,
      TooltipModule,
      CurrencyPipe,
      SelectModule
  ],
    template: `
<div class="flex flex-col gap-8">
            <div>
                <div class="flex flex-col gap-4" [formGroup]="editForm">
                    <div class="flex flex-col gap-2">
                        <label for="name1">Category</label>
                        <p-select [options]="userAccessService.foundersCategories()" 
                    [filter]="true"
                    filterBy="Name" 
                    formControlName="CategoryID" 
                    optionLabel="Name" 
                    optionValue="CategoryID" 
                    [pTooltip]="catLockout ? 'Only custom foundation is allowed on Founders plans' : 'Select a Category'" 
                    tooltipPosition="bottom" 
                    placeholder="Select a category"
                    id="cat">
                    </p-select>
                    </div>
                    <div class="flex flex-col gap-2">
                        <label for="email1">Description</label>
                        <app-rich-text-editor formControlName="Description"></app-rich-text-editor>
                    </div>
                    <div class="flex flex-wrap gap-4">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="price">Price</label>
                            <input pInputText id="price" type="number" formControlName="price" />
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="quantity">Quantity</label>
                            <input pInputText id="quantity" type="number" formControlName="quantity" />
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-4">
                        <div class="flex flex-col grow basis-0 gap-2">
                            <label for="name2">Total</label>
                            {{ assembly.total | currency }}
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                       
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-4">
                        <div class="flex flex-col grow basis-0 gap-2">
                        <button pButton label="Cancel" (click)="cancel()" severity="secondary"></button>
                        </div>
                        <div class="flex flex-col grow basis-0 gap-2">
                        <button pButton label="Save" (click)="save()" severity="primary"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class CustomAssemblyComponent {
  emptyAssembly = {
    Name: '',
    Description: '',
    Type: 'C',
    CategoryID: 0,
    Quantity: 1,
    total: 0,
    price: 0
  };

  catLockout: boolean = false;
  @Output() assemblySaved = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<any>();
  formChanged: boolean = false;
  changeCount: number = 0;
  initialFormValues: any = this.emptyAssembly;
  editForm: FormGroup;
  assembly: Partial<CatalogAssembly> = this.emptyAssembly;
  prefilledText: string = '';

  constructor(
    private fb: FormBuilder,
    public categoriesService: CategoriesService,
    public userAccessService: UserAccessService
  ) {
    this.categoriesService.loadCategories();
    this.editForm = this.fb.group({
      Name: [''],
      Description: [''],
      Type: ['C'],
      CategoryID: new FormControl({value: 0, disabled: this.catLockout}),
      quantity: [1],
      total: [0],
      price: [0]
  });

  effect(() => {
    const category = this.categoriesService.selectedCategory();
    if(this.userAccessService.foundersRestrictedAccess()) {
      this.prefilledText = 'Additional Foundation needed  per lot lot conditions';
      this.editForm.patchValue({
        Description: this.prefilledText,
        CategoryID: 322
      });
      this.catLockout = true;
    }
    if(category && !this.userAccessService.foundersRestrictedAccess()) {
      this.editForm.patchValue({
        CategoryID: category.CategoryID,
      });
      this.catLockout = false;
    }
  });
}

ngOnInit(): void {
  this.editForm.valueChanges.subscribe(values => {
    this.formChanged = true;
    this.assembly = { ...this.assembly, ...values };
    this.assembly.total = this.assembly.price && this.assembly.quantity ? this.assembly.price * this.assembly.quantity : 0;
    this.countChangedFields();
  });
}

countChangedFields() {
  this.changeCount = Object.keys(this.editForm.value).reduce((count, key) => {
    if (this.editForm.value[key] !== this.initialFormValues[key]) {
      return count + 1;
    }
    return count;
  }, 0);
}

save() {
  this.assemblySaved.emit(this.assembly);
}

cancel() {
  this.cancelled.emit(null);
}
}
